// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"c9768d97","787":"57b71871"}[chunkId] + ".chunk.js";
};